import styled from "@emotion/styled";
import theme from "@theme";
//#fff4fa
const Cardstyle = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.25rem;
  min-width: 300px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
    border-color: rgba(227, 110, 0, 0.3);
  }
  
  &:focus-within {
    outline: 2px solid rgba(227, 110, 0, 0.3);
    outline-offset: 2px;
  }
  
  @media (min-width: 640px) {
    padding: 2rem;
    border-radius: 1.5rem;
  }
  
  @media (min-width: 1024px) {
    padding: 2.5rem;
  }
  
  @media (min-width: 1280px) {
    padding: 3rem;
  }
`;

const ImageDiv = styled.div`
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.75rem;
  padding: 0.75rem;
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.15);
  border: 1px solid rgba(227, 110, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 8px 25px rgba(227, 110, 0, 0.2);
    transform: scale(1.02);
  }
  
  @media (max-width: 1024px) {
    padding: 0.5rem;
  }
`;

const ImageContainer = styled.img`
  height: 80px;
  width: 90px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border-radius: 0.5rem;

  @media (max-width: 1024px) {
    height: 70px;
    width: 80px;
  }
  
  @media (max-width: 768px) {
    height: 60px;
    width: 70px;
  }
`;

const logoBoxStyle = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    gap: 1rem;
    margin-bottom: 1rem;
  }
`;

const infoBoxStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 0.75rem;
  border: 1px solid rgba(227, 110, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(227, 110, 0, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }
  
  @media (max-width: 768px) {
    padding: 0.75rem;
  }
`;

const SC = {
  Cardstyle,
  logoBoxStyle,
  infoBoxStyle,
  ImageDiv,
  ImageContainer,
};

export default SC;
